import MainPage from "./pages/main/MainPage.vue"
import LoginPage from "./pages/login/LoginPage.vue"
import LoadingPage from "./pages/main/views/LoadingPage.vue"
import RegisterPage from "./pages/login/RegisterPage.vue"
import FindPasswordPage from "./pages/login/FindPasswordPage.vue"
import UserHomePage from "./pages/main/pages/home/UserHomePage.vue"
import NewWordPage from "./pages/main/pages/new-word/NewWordPage.vue"
import MyBookList from "./pages/main/pages/book/MyBookList.vue"
import OnlineStore from "./pages/main/pages/store/OnlineStore.vue"
import BookDetailsPage from "./pages/main/pages/book/BookDetailsPage.vue"
import SpellWordTools from "./pages/main/pages/learn/spell/SpellWordTools.vue"
import MySharePage from "./pages/main/pages/share/MySharePage.vue"
import BuyMemberPage from "./pages/main/pages/member/BuyMemberPage.vue"


const routes = [
    {
      path:'/',
      component:LoadingPage,
    },
    {
      path:'/main-page',
      component:MainPage,
      children:[
        {
          path:"",
          component:MyBookList
        },
        {
          path:"/user-home-page",
          component:UserHomePage
        },
        {
          path:"/my-book-list",
          component:MyBookList
        },
        {
          path:"/online-store",
          component:OnlineStore
        },
        {
          path:"/new-word-page",//新增单词窗口
          component:NewWordPage//NewWordWindow
        },
        {
          path:"/my-share-page",//分享计划窗口
          component:MySharePage//MyShareWindow
        },
        {
          path:"/buy-member-page",//购买会员窗口
          component:BuyMemberPage//BuyMemberWindow
        },
      ]
    },
    {
      path:"/book-details-page/:bookId",//图书详情窗口
      component:BookDetailsPage//BookDetailsWindow
    },
    {
      path:"/spell-word-tools",//拼写工具窗口
      component:SpellWordTools//SpellWordToolsWindow
    },
    {
      path:"/login-page",//登录窗口
      component:LoginPage//LoginWindow
    },
    {
      path:"/register-page/:shareCode?",//注册窗口
      component:RegisterPage,//RegisterWindow.
      props: true
    },
    {
      path:"/find-password-page",//找回密码窗口
      component:FindPasswordPage//FindPasswordWindow
    }

]

export default routes